import React from "react";
import { Descriptions, Space } from "antd";
import { useSelector } from "react-redux";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  GatewayOutlined,
} from "@ant-design/icons";
import styles from "./index.module.less";

function DetectionInformationPanel() {
  const detection = useSelector((state) => state.panel.detection);
  if (!detection) {
    return null;
  }
  return (
    <div className={`${styles.detectionInformationPanel} panel-container`}>
      <Descriptions column={1}>
        <Descriptions.Item
          label={
            <Space>
              <CalendarOutlined />
              <span>Sea ice image date</span>
            </Space>
          }
          labelStyle={{ width: 180 }}
        >
          2021-09-10 14:20:10
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <Space>
              <EnvironmentOutlined />
              <span>Sea ice image position</span>
            </Space>
          }
          labelStyle={{ width: 180 }}
        >
          100.3, 78,6
        </Descriptions.Item>
        <Descriptions.Item
          label={
            <Space>
              <GatewayOutlined />
              <span>Sea ice area</span>
            </Space>
          }
          labelStyle={{ width: 180 }}
        >
          25.4 km2
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}

export default DetectionInformationPanel;
